import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { getLocaleDateTime, getUserFullName } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import DshBoxTitle from '../Box/DshBoxTitle';
import '../styles/customComponentCss.css';

function PreviousReviewListTable({ agendaReviews }) {
  const { baseFontSize, smallFontSize } = useTemplateFontSettings();
  const userList = useSelector((state) => state.user.data);

  return (
    <div>





      <DshBoxTitle color="subheader" title={agendaReviews.length > 0 ? "Değerlendirme Sonuçları" : "Değerlendirme Sonucu Yok"} />


      {agendaReviews && agendaReviews.length > 0 && (
        <Table style={{ margin: 0, padding: 0, lineHeight: 1 }} size="small" className="small-font-table">
          <TableHead>
          </TableHead>

          <TableBody>
            {agendaReviews.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                  style={{
                    width: "100%",
                    fontSize: baseFontSize,
                    paddingBottom: 0,
                    paddingTop: 2,
                    paddingLeft: 5,
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
                  }}
                >
                  {(() => {
                    const user = userList.find((user) => user.id === item.userId);

                    return (
                      <>
                        <span style={{ fontStyle: "italic", fontWeight: 500, fontSize: baseFontSize }}>{getUserFullName(user)}</span>{" "}
                        <span style={{ fontStyle: "italic", fontSize: smallFontSize, color: '#788490' }}>
                          ({getLocaleDateTime(item.pdate)}):
                        </span>
                        {" "}{item.info}
                      </>
                    );

                  })()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default PreviousReviewListTable;